import {RegisterStatus, ActionTypes} from 'store/actions/modals/register';

/**
 * Status logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function status (state = RegisterStatus.INITIAL, action) {

    switch (action.type) {

        case ActionTypes.SET_REGISTER_FORM_STATUS:
            return action.status;

        default:
            return state;
    }
}

/**
 * Form data logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function formData (state = {}, action) {

    switch (action.type) {

        case ActionTypes.SET_REGISTER_FORM_DATA:
            return Object.assign({}, state, action.formData);
        case ActionTypes.RESET_REGISTER_FORM_DATA:
            return {};
        default:
            return state;
    }
}

/**
 * Error logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function getFormError (state = '', action) {

    switch (action.type) {

        case ActionTypes.SET_REGISTER_FORM_ERROR:
            return action.formError || '';

        default:
            return state;
    }
}

/**
 * Product price state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function getProductPrice (state = {}, action) {

    switch (action.type) {

        case ActionTypes.SET_REGISTER_PRODUCT_PRICE:
            return action.productPrice || {};

        default:
            return state;
    }
}

/**
 * Register reducer.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Action payload.
 * @returns {Object} Register reducer.
 */
export default function register (state = {}, action) {

    return {
        status: status(state.status, action),
        formData: formData(state.formData, action),
        formError: getFormError(state.formError, action),
        productPrice: getProductPrice(state.productPrice, action)
    };
}


// WEBPACK FOOTER //
// ./src/js/store/reducers/modals/register.js